import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Typography, Box, FormControl, InputLabel, Select, MenuItem, Button, DialogContent, TextField, Grid, FormControlLabel, Divider, Chip } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Dialog } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { Add, AddBox, CheckBox, CheckBoxTwoTone, Delete, Edit, Square } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

// import { DataGrid } from '@mui/x-data-grid';

function Countrymas() {
  const [CountryData, setCountryData] = useState(null);
  const [flg, setflg] = useState(false);
  const swal = useSwalWrapper()
  const {rights} = useJumboAuth()
const fetchCountryData = useCallback(()=>{
  setCountryData(null)
  jwtAuthAxios.get(`master/helper?country=1`).then(res=>{
    setCountryData(res.data.data.COUNTRY)
  })
})
useEffect(()=>{
  fetchCountryData()

},[])

const formEditSubmitHandler = async(row,iid)=>{
  const {FL_COUNTRY_CD,FL_COUNTRY_NAME,FL_COUNTRY_CODE,FL_COUNTRY_SHORT} = row
  // console.log(row,document.getElementById(`detail-a-${index}`).value,document.getElementById(`detail-b-${index}`).value);
  // console.log({ FL_COUNTRY_CD:FL_COUNTRY_CD,
  //   FL_COUNTRY_NAME : document.getElementById(`${iid}-a`).value,
  //   FL_COUNTRY_CODE : document.getElementById(`${iid}-b`).value,
  //   FL_COUNTRY_SHORT : document.getElementById(`${iid}-c`).value
  // });
  // return
  await jwtAuthAxios.post('master/countryaddEdit',
  { FL_COUNTRY_CD:FL_COUNTRY_CD,
    FL_COUNTRY_CODE : document.getElementById(`${iid}-a`).value,
    FL_COUNTRY_NAME: document.getElementById(`${iid}-b`).value,
    FL_COUNTRY_SHORT : document.getElementById(`${iid}-c`).value
  }).then(res =>{
    swal.fire({
      icon:'success',
      text:res.data.message,
    })
    // callback()
    }).catch(()=>{
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });
  })
}
  return (<>
    {CountryData?.length >0 ? 
      <TableContainer  component={Paper}>
        <Table size='small' >
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>CODE</TableCell>
              <TableCell>NAME</TableCell>
              <TableCell>SHORT</TableCell>
              <TableCell align='right'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {CountryData?.map((Data,index)=> 
          <TableRow key={index}>
            <TableCell>{Data.FL_COUNTRY_CD}</TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_COUNTRY_CD}-a`} defaultValue={Data.FL_COUNTRY_CODE} /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_COUNTRY_CD}-b`} defaultValue={Data.FL_COUNTRY_NAME} /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-${Data.FL_COUNTRY_CD}-c`} defaultValue={Data.FL_COUNTRY_SHORT} /></TableCell>
              {/* <TableCell><TextField size='small' fullWidth id={`detail-${selectedParamType.FL_COUNTRY_CD}-d`} defaultValue={selectedParamType.FL_COUNTRY_CD} /></TableCell> */}
              {/* <TableCell>{Data.FL_COUNTRY_CODE}</TableCell>
              <TableCell>{Data.FL_COUNTRY_NAME}</TableCell>
              <TableCell>{Data.FL_COUNTRY_SHORT}</TableCell> */}
              <TableCell>
              {rights?.edit ==1 && <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler(Data,`detail-${Data.FL_COUNTRY_CD}`)}} color='primary'>Save</LoadingButton>}
              {rights?.delete ==1 &&<LoadingButton variant='contained' size='small' sx={{ ml: 2 }} onClick={()=>{jwtAuthAxios.get('master/deleteCountrymsmas/'+Data.FL_COUNTRY_CD).then(()=> {fetchCountryData()})}} color='error'>Delete</LoadingButton>}
              </TableCell>
            </TableRow>)
          }
          {rights?.insert==1&& <TableRow>
            <TableCell>{'-'}</TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-a`}  /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-b`}  /></TableCell>
              <TableCell><TextField size='small' fullWidth id={`detail-new-c`}  /></TableCell>
              <TableCell>
              <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler({FL_COUNTRY_CD:null},`detail-new`)}} color='primary'>Save</LoadingButton>
              </TableCell>
            </TableRow>}
          </TableBody>
        </Table>
      </TableContainer> :<TableSkeleton cols={7} />}</>
  );
}



Countrymas.Modulename = 'Countrymas'
export default Countrymas;
